import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3" }
const _hoisted_2 = { class: "tw-w-32 tw-flex-none" }
const _hoisted_3 = {
  key: 0,
  class: "tw-cursor-pointer tw-rounded-md"
}
const _hoisted_4 = { class: "tw-flex-0 tw-flex tw-rounded-md tw-border" }
const _hoisted_5 = { class: "tw-flex-1 tw-text-center md:-tw-mt-px md:tw-flex" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "tw-flex-0 tw-w-32" }
const _hoisted_8 = {
  key: 0,
  class: "tw-cursor-pointer tw-rounded-md"
}
const _hoisted_9 = { class: "tw-flex-0 tw-flex tw-rounded-md tw-border" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronDoubleLeft = _resolveComponent("ChevronDoubleLeft")!
  const _component_ChevronDoubleRight = _resolveComponent("ChevronDoubleRight")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.shouldHidePreviousCta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                "data-testid": "first-page-cta",
                class: "tw-block tw-items-center tw-border-r tw-p-2 tw-text-xs tw-font-medium tw-text-slate-500",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToFirstPage && _ctx.goToFirstPage(...args)))
              }, [
                _createVNode(_component_ChevronDoubleLeft, { class: "tw-h-4 tw-w-4" })
              ]),
              _createElementVNode("div", {
                id: "previous-button",
                class: "tw-inline-flex tw-w-24 tw-items-center tw-justify-center tw-p-2 tw-pr-3 tw-text-xs tw-font-medium tw-text-slate-500 hover:tw-border-slate-300",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickPrevious && _ctx.onClickPrevious(...args)))
              }, " Previous ")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "tw-mx-auto tw-text-xs tw-text-slate-400",
        innerHTML: _ctx.text
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.shouldHideNextCta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                id: "next-button",
                class: "tw-inline-flex tw-w-24 tw-items-center tw-justify-center tw-p-2 tw-pl-3 tw-text-xs tw-font-medium tw-text-slate-500 hover:tw-border-slate-300",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickNext && _ctx.onClickNext(...args)))
              }, " Next "),
              _createElementVNode("div", {
                "data-testid": "last-page-cta",
                class: "tw-block tw-items-center tw-border-l tw-p-2 tw-text-xs tw-font-medium tw-text-slate-500",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToLastPage && _ctx.goToLastPage(...args)))
              }, [
                _createVNode(_component_ChevronDoubleRight, { class: "tw-h-4 tw-w-4" })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}